import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { multiClientMenuFilters } from '../mtEnterprises';
const routes = {
  name: 'Operations',
  icon: 'mdi-clipboard-text-outline',
  path: '/reports/shift',
  menuFilters: multiClientMenuFilters,
  ...addPermissionsToRoute(['mtShift']),
  children: [
    {
      path: '/reports/shift/dailyActivity',
      name: 'Daily Activity Report',
      meta: { id: 'mt-dailyActivity' },
      component: () => import('./DailyActivityReport.vue'),
      ...addPermissionsToRoute(['mtDailyActivity']),
    },
    {
      path: '/reports/shift/opsReport',
      name: 'Operations Report',
      meta: { id: 'mt-opsReport' },
      component: () => import('./opsReport/OpsReportWrapper.vue'),
    },
  ],
};

export default routes;
